// frontend/src/core/services/inspectionService.ts
import { apiClient } from './apiClient';
import { Inspection, SubmitInspectionPayload } from '@core/types';
import { offlineManager } from '@shared/utils/offlineManager';

export const inspectionService = {
  /**
   * Envía una inspección. Si está offline, la guarda en la cola local.
   */
  async submit(payload: SubmitInspectionPayload): Promise<Inspection> {
    // Si estamos offline, guardar en cola
    if (!navigator.onLine) {
      const pendingId = await offlineManager.addPendingInspection(payload);
      throw new Error(`Offline: Inspección guardada para sincronizar (ID: ${pendingId})`);
    }

    try {
      // 🔥 CAMBIO: eliminar '/api' del inicio
      const result = await apiClient.post<Inspection>('/inspections/submit', payload);
      return result;
    } catch (error) {
      // Si falla por red (NetworkError), guardar offline
      if (error instanceof TypeError && error.message.includes('NetworkError')) {
        const pendingId = await offlineManager.addPendingInspection(payload);
        throw new Error(`Error de red: Inspección guardada para sincronizar (ID: ${pendingId})`);
      }
      throw error;
    }
  },

  async getByChecklist(checklistId: string): Promise<Inspection[]> {
    // 🔥 CAMBIO: eliminar '/api' del inicio
    return apiClient.get<Inspection[]>(`/inspections/checklist/${checklistId}`);
  },

  async getById(id: string): Promise<Inspection> {
    // 🔥 CAMBIO: eliminar '/api' del inicio
    return apiClient.get<Inspection>(`/inspections/${id}`);
  },

  async generateReport(id: string, format: 'PDF' | 'EXCEL' = 'PDF'): Promise<Blob> {
    // 🔥 CAMBIO: eliminar '/api' del inicio
    const response = await apiClient.get<Blob>(`/inspections/${id}/report`, {
      params: { format },
      responseType: 'blob',
    });
    return response as unknown as Blob;
  },
};